import api from '@/utils/api';

const state = {};
const mutations = {};

const getters = {};
const actions = {
  // 获取提醒/质询列表
  async api_create_complaint(_commit, params) {
    return api.post('/api/complaint/submit', params);
  },
  async api_create_complaint_logout(_commit, params) {
    return api.post('/api/complaint/submitLogout', params);
  },
  // 查询用户misId
  async api_query_org_misid_strict(_commit, params) {
    return api.post('/api/orgdata/query_mis_strict', params);
  },
  async api_query_org_misid_list(_commit, params) {
    return api.post('/api/orgdata/query_mis_id_list', params);
  },
  async api_query_all_bu() {
    return api.post('/api/orgdata/query_all_bu');
  },
  async api_get_page_info_logout(_commit, params) {
    return api.get('/api/complaint/getPageInfoLogout', {params: params});
  },
  async api_get_page_info(_commit, params) {
    return api.get('/api/complaint/getPageInfo', {params: params});
  },
  async api_get_iam_page_info_logout(_commit, params) {
    return api.get('/api/complaint/getIamPageInfoLogout', {params: params});
  },
  async api_query_sub_org(_commit, params) {
    return api.post('/api/orgdata/query_sub_org', params);
  },
  async api_query_org_list(_commit, params) {
    return api.post('/api/orgdata/query_org_list', params);
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};
